"use strict";

let ForClipboard = {
    options: {
        selector: ".for-clipboard",
    },
};

ForClipboard.init = function (userOptions) {
    for (var prop in userOptions) {
        if (Object.prototype.hasOwnProperty.call(this.options, prop)) {
            this.options[prop] = userOptions[prop];
        }
    }

    this.initSelectors(document);
}

ForClipboard.initSelectors = function (rootElement) {
    let buttonElements = rootElement.querySelectorAll(this.options.selector);

    let self = this;

    buttonElements.forEach(function (buttonElement) {
        if (buttonElement.hasOwnProperty('moduleForClipboardInitialized')) { return; }
        buttonElement.moduleForClipboardInitialized = true;

        buttonElement.addEventListener("click", function (event) {
            event.stopPropagation();
            navigator.clipboard.writeText(buttonElement.dataset.text)
                .then(() => {
                    console.log("Copied!");
                })
                .catch((error) => {
                    console.error("Write to clipboard failed: ", error);
                })
        });
    });
}

export {ForClipboard};